import { render, staticRenderFns } from "./SplitToBase.vue?vue&type=template&id=bbfca366&scoped=true"
import script from "./SplitToBase.vue?vue&type=script&lang=ts"
export * from "./SplitToBase.vue?vue&type=script&lang=ts"
import style0 from "./JobActions.scss?vue&type=style&index=0&id=bbfca366&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfca366",
  null
  
)

export default component.exports